// extracted by mini-css-extract-plugin
module.exports = {"no-suggestions":"styles-module__no-suggestions___1F1wv","suggestions":"styles-module__suggestions___3jRIw","suggestion-active":"styles-module__suggestion-active___x3ZXM"};